import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
	@Input() updateVideo: boolean; // 是否为上传视频
	@Input() content: string;

  constructor() { }

  ngOnInit() {}

}
